export enum FormRateDataType {
  Flexible = 'formRateDataFlexible',
  NonRefundable = 'formRateDataNonRefundable',
  Custom = 'formRateDataPersonalized'
}
export interface FormRateDataFlexibleChargePolicy {
  cobrar100AlReservar?: boolean
  cobrar50AlReservarY50ALaEntrada?: boolean
  cobrarCostePrimeraNocheAlReservarYRestoALaEntrada?: boolean
}

export interface FormRateDataFlexibleBail {
  fianzaValor: string
  fianzaPorcentajeId: string
  fianzaCobroALaEntrada?: boolean
  fianzaCobroPersonalizada?: boolean
  fianzaCobroValor: string
  fianzaCobroTiempoId: string
  fianzaCobroMomentoId?: string
  fianzaCobroTodasLasReservas?: boolean
  fianzaCobroNochesMinimas?: boolean
  fianzaCobroNochesMinimasValor?: number
  fianzaDevolucionALaSalida?: boolean
  fianzaDevolucion24HorasDespuesDeLaSalida?: boolean
  fianzaDevolucion48HorasDespuesDeLaSalida?: boolean
  fianzaDevolucionPersonalizado?: boolean
  fianzaDevolucionPersonalizadoValor?: string
  fianzaDevolucionPersonalizadoTiempoId?: string
  fianzaDevolucionPersonalizadoMomentoId?: string
}

export interface FormRateDataFlexibleConditions {
  idiomaId: string
  nombre?: string
  condiciones?: string
}

export interface FormRateDataFlexibleInherited {
  idTarifaPadre: string
  nombreTarifaPadre?: string
  valor: string
  signoId: string
  porcentajeId: string
}

export interface FormRateDataAdvancePayment {
  cobrarAnticipo?: boolean
  anticipoPrimeraNoche?: boolean
  mitadDelPorcentajeDeLaReserva?: boolean
  anticipoPersonalizado?: boolean
  anticipoValor?: string
  anticipoPorcentajeId?: string
  cobrarAnticipoAlReservar?: boolean
  cobrarAnticipoPersonalizado?: boolean
  cobrarAnticipoValor?: string
  cobrarAnticipoTiempoId?: string
  cobrarAnticipoMomentoId?: string
}

export interface RangoEdadList {
  desde: string
  hasta: string
  valor: string
  signoId: string
  porcentajeId: string
}

export interface FormRateDataChildrenRates {
  mismoPrecioAdultoQueNino?: boolean
  hasta3anosLosNinosNoPagan?: boolean
  precioNinosPersonalizado?: boolean
  rangoEdadList?: RangoEdadList[]
  todoLosNinosDeLaReservaPagan?: boolean
  primerNinoGratisElRestoPagan?: boolean
  primerYSegundoNinoGratisElRestoPagan?: boolean
}

export interface FormRateDataChargeRestOfRate {
  cobrarALaEntrada?: boolean
  cobrar24HorasAntesDeLaEntrada?: boolean
  cobrar48HorasAntesDeLaEntrada?: boolean
  cobrarPersonalizado?: boolean
  cobrarValor?: string
  cobrarTiempoId?: string
  cobrarMomentoId?: string
}

export interface FormRateDataCustomExtraList {
  id: string
  extraSeAnadeUnaSolaVez?: boolean
  extraPersonalizado?: boolean
  extraSeAnadePorCadaDiaDeLaReserva?: boolean
  extraSeAnadePorCadaPersonaDeLaReserva?: boolean
  extraCosteSumarloAlPrecioDeLaTarifa?: boolean
  extraCosteIncluidoEnElPrecioDeLaTarifa?: boolean
  crearIngresoIndependienteParaElCargoDelExtra?: boolean
}

export interface FormRateDataCancellationPolicy {
  politicaCancelacion50HastaSieteDiasAntesDeLaEntrada?: boolean
  politicaCancelacion100HastaSieteDiasAntesDeLaEntrada?: boolean
  politicaCancelacionPersonalizado?: boolean
  politicaCancelacionValor?: string
  politicaCancelacionPorcentajeId?: string
  politicaCancelacionDias?: string
  politicaCancelacionTiempoId?: string
  politicaCancelacionMomentoId?: string
}

export interface BaseFormRateData {
  nombreTarifa: string
  rateId: string
  impuestoTarifaId: string
  regimenTarifaId: string
  tipologiaINETarifaId: string
  diasMinimosTarifa?: number
  ventana?: FormRateDataType
  tarifaDerivada?: FormRateDataFlexibleInherited
  fianzaTarifa?: FormRateDataFlexibleBail
  condiciones?: FormRateDataFlexibleConditions[]
  extraList?: { id: string }[]
  // extraList?: {id:string}[]
  channelList?: string[]
  roomTypeList?: string[]
}

export interface FormRateDataFlexible extends BaseFormRateData {
  politicaCancelacion?: { politicaCancelacionId: string }
  politicaCobro?: FormRateDataFlexibleChargePolicy
}

export interface FormRateDataNonRefundable
  extends Omit<BaseFormRateData, 'politicaCancelacion'> {
  tiempoCortesiaCancelacion?: string
}

export interface FormRateDataPersonalized
  extends Omit<
    BaseFormRateData,
    'extraList' | 'politicaCancelacion' | 'extraList'
  > {
  refundable?: boolean
  notRefundable?: boolean
  anticipoTarifa?: FormRateDataAdvancePayment
  politicaCancelacion?: FormRateDataCancellationPolicy
  cobroReserva?: FormRateDataChargeRestOfRate
  importeNinos?: FormRateDataChildrenRates
  extraList?: FormRateDataCustomExtraList[]
}

export type FormRateData =
  | FormRateDataFlexible
  | FormRateDataNonRefundable
  | FormRateDataPersonalized

export type FormRate =
  | {
      [FormRateDataType.Flexible]: FormRateDataFlexible
    }
  | { [FormRateDataType.NonRefundable]: FormRateDataNonRefundable }
  | { [FormRateDataType.Custom]: FormRateDataPersonalized }
